import { useCredits } from "@/hooks/useCredits";
import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";

export default function CreditsDisplay() {
  const { creditBalance, isLoading } = useCredits();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-11 w-20 rounded-full border-2 border-gray-900 dark:border-gray-300 bg-white/90 dark:bg-gray-700/90">
        <div className="w-4 h-4 bg-gray-300 dark:bg-gray-600 rounded-full animate-pulse" />
      </div>
    );
  }

  if (creditBalance === null) {
    return null;
  }

  const balanceDollars = (creditBalance / 100).toFixed(2);

  return (
    <div
      className={cn(
        "flex items-center justify-center gap-1 h-11 px-2.5 rounded-full border-2 border-gray-900 dark:border-gray-300 bg-white/90 dark:bg-gray-700/90 text-xs font-semibold text-gray-900 dark:text-white whitespace-nowrap",
        theme.shadows.neubrutalism3,
        "transition-transform hover:-translate-y-0.5",
      )}
      title={`$${balanceDollars} credits`}
    >
      <span className="text-sm">💰</span>
      <span>${balanceDollars}</span>
    </div>
  );
}

